import UNAM from '../../../assets/signatire_karina.png';
import PropTypes from 'prop-types';
import Logos from "../../../assets/acceptance-letter/4x/banner_carta@4x.png";
import {useEffect, useState} from "react";

export const AcceptanceLetterComponent = ({ abstract }) => {
  const [authorsString, setAuthorString] = useState('');

  const Print = () => {
    //console.log('print');
    let printContents = document.getElementById('printablediv').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  useEffect(() => {
    let tempAuthorString = '';

    if (abstract === undefined) {
      return;
    }

    for (const author of abstract.authors) {
      // Add ", " to tempAuthorString if is not the first author
      if (tempAuthorString.length > 0) {
        tempAuthorString += ', ';
      }
      if (author.name === undefined) {
        continue;
      }
      tempAuthorString += `${author.lastName} ${
          author.name.length > 0 ? author.name[0] + '.' : ''
      }`;
    }
    setAuthorString('<p>' + tempAuthorString + '</p>');
  }, [abstract]);

  return (
    <>
      <button className="print-button" onClick={Print}>
        <span className="material-symbols-outlined">print</span> Print
      </button>
      <div id="printablediv" className="acceptance-letter-wrapper">
        <div className="acceptance-letter-logos-wrapper">
          <img src={Logos} alt="Proceeding logos" />
        </div>
        <p className="acceptance-letter-title">ACCEPTANCE LETTER</p>
        <div className="acceptance-letter-text-wrapper">
          <p>
            Dear{' '}
            <strong>
              {abstract.authors[0].lastName} {abstract.authors[0].name[0]}.,
            </strong>
          </p>
          <p>
            On behalf of the Organizing Committee, it is my pleasure to inform you that the abstract
            entitled:
          </p>
          <p>
            <strong>
              “{abstract.title}.”
            </strong>
          </p>
          <p>
            Authors: <strong dangerouslySetInnerHTML={{ __html: authorsString }} />
          </p>
          <p>
            Has been accepted as {abstract.accepted === "poster" ? "a" : "an"}  {abstract.accepted} presentation in the Energy Storage Discussion 2025 to be held in Ensenada, Baja California from November 19 to 21, 2025.
          </p>
          {abstract.presentation_type === 'oral' ? (
            <p>
              We invite you to register on the website before April 15, 2024. In the case of oral
              presentation, if you are not registered by May 1st your work might be changed to
              poster. Please send an email with confirmation of your presence since this is an
              in-person presentation.
            </p>
          ) : null}

          <p>Sincerely,</p>
          <div className="acceptance-letter-signature-wrapper">
            <p className="acceptance-letter-signature-name">Dra. Ana Karina Cuentas Gallegos</p>
            <p className="acceptance-letter-signature-position">Representative of Red Mexicana de Almacenamiento de Energía (RMAE)</p>
          </div>
          <img className="unam" src={UNAM} alt="UNAM" />
        </div>
      </div>
    </>
  );
};

AcceptanceLetterComponent.propTypes = {
  abstract: PropTypes.any.isRequired,
};
